import type { MediaLibrarySearchFileResponse } from '../interfaces'

type BuildOpts = {
  mediaCollectionRoute?: boolean
  currentMediaCollection?: string
  file: MediaLibrarySearchFileResponse
}
export function useBuildDetailUrl({ mediaCollectionRoute, currentMediaCollection, file }: BuildOpts): string {
  if(!file)
  {
    return ''
  }
  const { type, fileId, versionInfo } = file


  const versionSuffix = type === 'file-version' && versionInfo?.id ? `/${versionInfo.id}` : ''

  let pathname: string
  if (mediaCollectionRoute) {
    pathname = `/dashboard/media-collections/${currentMediaCollection}/detail/${fileId}${versionSuffix}`
  } else {
    pathname = `/dashboard/media-library/detail/${fileId}${versionSuffix}`
  }

  return pathname
}
